module.exports = __webpack_public_path__ + "img/good-boi.919691cc.jpg";